import type React from 'react'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import { LANGUAGES } from '@/constants'
import { useLanguage } from '@/landing/contexts/LanguageContext'

export const LanguageSwitcher: React.FC = () => {
  const { locale, setLocale } = useLanguage()
  const currentLanguage = LANGUAGES.find((lang) => lang.code === locale) || LANGUAGES[0]

  const handleLanguageChange = (langCode: string) => {
    setLocale(langCode)
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button type="button" className="flex items-center gap-2 p-2 outline-none cursor-pointer">
          {/* Mobile: flag in circle */}
          <div className="h-9 w-9 rounded-full bg-gray-100 hover:bg-gray-200 flex items-center justify-center sm:hidden transition-colors">
            <img
              src={currentLanguage.flag}
              alt={currentLanguage.label}
              className="w-6 h-4 object-cover"
            />
          </div>
          {/* Desktop: flag + label with rounded hover */}
          <div className="hidden sm:flex items-center gap-2 px-2 py-1 rounded-md hover:bg-accent transition-colors">
            <img
              src={currentLanguage.flag}
              alt={currentLanguage.label}
              className="w-6 h-4 object-cover"
            />
            <span
              className="hidden lg:inline text-sm font-medium"
              style={{
                fontFamily: 'Montserrat, sans-serif',
              }}
            >
              {currentLanguage.label}
            </span>
          </div>
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-48 p-2 border-gray-200 shadow-none">
        {LANGUAGES.map((lang) => (
          <DropdownMenuItem
            key={lang.code}
            onClick={() => handleLanguageChange(lang.code)}
            className={`cursor-pointer rounded-md p-3 hover:bg-accent transition-colors ${
              locale === lang.code ? 'bg-accent' : ''
            }`}
          >
            <img src={lang.flag} alt={lang.label} className="w-6 h-4 object-cover mr-3" />
            <span
              className="font-medium"
              style={{
                fontFamily: 'Montserrat, sans-serif',
              }}
            >
              {lang.label}
            </span>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
